import React from 'react';
import Lottie from 'lottie-react';

import tutorialAnimation from '../../assets/animations/streams.json';

const TutorialAnimation = () => {
  return <Lottie animationData={tutorialAnimation} />;
};

export default <TutorialAnimation />;